import React, { useEffect, useState } from 'react';
import {
  Card,
  Form,
  Input,
  Button,
  Table,
  Space,
  message,
  InputNumber,
  Checkbox,
  Spin,
} from 'antd';
import api from '../../services/api';

export default function ResponsaveisPage() {
  const [lista, setLista] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [form] = Form.useForm();
  const [formVinculo] = Form.useForm();

  // ===============================
  // CARREGAR RESPONSÁVEIS
  // ===============================
  const carregar = async () => {
    setLoading(true);
    try {
      const res = await api.get('/creche/responsaveis');
      setLista(res.data?.data || []);
    } catch (e) {
      console.error(e);
      message.error('Erro ao carregar responsáveis.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregar();
  }, []);

  // ===============================
  // CRIAR RESPONSÁVEL
  // ===============================
  const criar = async (values) => {
    setSubmitting(true);
    try {
      await api.post('/creche/responsaveis', values);
      message.success('✅ Responsável criado com sucesso.');
      form.resetFields();
      carregar();
    } catch (e) {
      console.error(e);
      message.error('❌ Falha ao criar responsável.');
    } finally {
      setSubmitting(false);
    }
  };

  // ===============================
  // VINCULAR CRIANÇA → RESPONSÁVEL
  // ===============================
  const vincular = async (values) => {
    setSubmitting(true);
    try {
      await api.post('/creche/crianca-responsavel', {
        estudanteId: values.estudanteId,
        responsavelId: values.responsavelId,
        parentesco: values.parentesco,
        titularFinanceiro: !!values.titularFinanceiro,
        autorizacaoLevantar: !!values.autorizacaoLevantar,
        prioridadeContato: values.prioridadeContato || 1,
      });
      message.success('✅ Vínculo criado com sucesso.');
      formVinculo.resetFields();
      carregar();
    } catch (e) {
      console.error(e);
      message.error('❌ Falha ao criar vínculo.');
    } finally {
      setSubmitting(false);
    }
  };

  // ===============================
  // TABELA DE RESPONSÁVEIS
  // ===============================
  const columns = [
    { title: 'ID', dataIndex: 'id', width: 80 },
    { title: 'Nome', dataIndex: 'nome' },
    { title: 'Telefone', dataIndex: 'telefone' },
    { title: 'Email', dataIndex: 'email' },
    { title: 'Nuit', dataIndex: 'nuit' },
    { title: 'Endereço', dataIndex: 'endereco' },
  ];

  // ===============================
  // JSX
  // ===============================
  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <h1 className="text-2xl font-bold mb-6">Gestão de Responsáveis</h1>

      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Card title="Novo Responsável">
          <Form
            layout="vertical"
            form={form}
            onFinish={criar}
            disabled={submitting}
          >
            <Form.Item
              name="nome"
              label="Nome completo"
              rules={[{ required: true, message: 'Informe o nome completo' }]}
            >
              <Input placeholder="Ex: Maria João" />
            </Form.Item>

            <Form.Item name="telefone" label="Telefone">
              <Input placeholder="Ex: +258 84 000 0000" />
            </Form.Item>

            <Form.Item
              name="email"
              label="E-mail"
              rules={[{ type: 'email', message: 'E-mail inválido' }]}
            >
              <Input placeholder="Ex: maria@email.com" />
            </Form.Item>

            <Form.Item name="nuit" label="NUIT">
              <Input placeholder="Ex: 123456789" />
            </Form.Item>

            <Form.Item name="endereco" label="Endereço">
              <Input placeholder="Ex: Bairro Central, Marracuene" />
            </Form.Item>

            <Button
              type="primary"
              htmlType="submit"
              loading={submitting}
              className="mt-2"
            >
              Salvar
            </Button>
          </Form>
        </Card>

        <Card title="Vincular Responsável a uma Criança">
          <Form
            layout="vertical"
            form={formVinculo}
            onFinish={vincular}
            disabled={submitting}
          >
            <Form.Item
              name="estudanteId"
              label="ID do Estudante"
              rules={[{ required: true, message: 'Informe o ID do estudante' }]}
            >
              <InputNumber min={1} style={{ width: '100%' }} />
            </Form.Item>

            <Form.Item
              name="responsavelId"
              label="ID do Responsável"
              rules={[{ required: true, message: 'Informe o ID do responsável' }]}
            >
              <InputNumber min={1} style={{ width: '100%' }} />
            </Form.Item>

            <Form.Item
              name="parentesco"
              label="Parentesco"
              rules={[{ required: true, message: 'Informe o grau de parentesco' }]}
            >
              <Input placeholder="Ex: Mãe, Pai, Tia..." />
            </Form.Item>

            <Form.Item name="prioridadeContato" label="Prioridade de Contato">
              <InputNumber min={1} max={5} style={{ width: '100%' }} />
            </Form.Item>

            <Form.Item
              name="titularFinanceiro"
              valuePropName="checked"
              label=" "
            >
              <Checkbox>Titular Financeiro</Checkbox>
            </Form.Item>

            <Form.Item
              name="autorizacaoLevantar"
              valuePropName="checked"
              label=" "
            >
              <Checkbox>Autorizado a Levantar Criança</Checkbox>
            </Form.Item>

            <Button
              type="primary"
              htmlType="submit"
              loading={submitting}
              className="mt-2"
            >
              Vincular
            </Button>
          </Form>
        </Card>

        <Card title="Lista de Responsáveis">
          {loading ? (
            <div className="text-center p-8">
              <Spin size="large" />
            </div>
          ) : (
            <Table
              rowKey="id"
              dataSource={lista}
              columns={columns}
              pagination={{ pageSize: 10 }}
            />
          )}
        </Card>
      </Space>
    </div>
  );
}
